
import * as React from 'react';

export function formatDynamic(format: Array<any>, value: any, value_raw: any, forExport?: boolean) {
    const style: any = {};
    style.width = '100%';
    style.height = '100%';

    let matched = false;
    format.forEach((f: any) => {
        if (f.type === 'default' && !matched) { // Default nur wenn noch kein Match
            applyFormat(style, f);
        }
        if (f.type === 'range' && f.from !== undefined && f.from <= +value_raw && f.to !== undefined && f.to >= +value_raw) {
            applyFormat(style, f);
            matched = true;
        }
    });
    if (forExport) {
        return value;
    }
    return <div className='value_export' style={style}> {value} </div>;
}

function applyFormat(style: any, format: any) {
    if (format.color) {
        style.color = format.color;
    }
    if (format.bgcolor) {
        style.backgroundColor = format.bgcolor;
    }
    if (format.align) {
        style.textAlign = format.align;
    }
}
